import React from 'react';
import { Button } from './ui/button';

const CTASection = ({ onOpenModal }) => {
  return (
    <section className="py-12 relative overflow-hidden">
      {/* Background Image with Overlay - Modern Abstract Waves */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://images.unsplash.com/photo-1759266585745-69800edcd54d)`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#012169]/95 via-[#013d9e]/95 to-[#012169]/95"></div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#F97316] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#F97316] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-[0_4px_20px_rgba(0,0,0,0.3)] leading-tight">
          Secure Your Trademark Before Competitors
        </h2>
        <p className="text-base sm:text-base md:text-base text-white/90 mb-6 max-w-3xl mx-auto leading-relaxed">
          Don't risk losing your brand name. Get started with a free trademark consultation and comprehensive USPTO search. Protect your business today with licensed IP attorneys.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - CTA Section')}
            className="bg-gradient-to-r from-[#F97316] to-[#EA580C] hover:from-[#EA580C] hover:to-[#F97316] text-white font-semibold text-base px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Start Trademark Registration
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => onOpenModal && onOpenModal('Discuss with Attorney - CTA Section')}
            className="border-2 border-white text-white hover:bg-white hover:text-[#012169] font-semibold text-base px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105 backdrop-blur-sm bg-white/10"
          >
            Discuss with Attorney
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;